// extracted by mini-css-extract-plugin
module.exports = {"card":"BaseCard_card__GmkWA","content":"BaseCard_content__a4pUe","title":"BaseCard_title__u2Zkr","button":"BaseCard_button__6B7UE"};